import { Section } from '@playbooks/core/src/interfaces'
import { BaseNode } from '../..'

export class SectionNode extends BaseNode {
  declare data: Section

  public getLabelTemplate(): string {
    return this.data.name
  }
}
